import ValuePicker from './ValuePicker'

export default ValuePicker
